import { logger } from '@carbonara/logger'
import { type IntlShape, createIntl, createIntlCache } from '@formatjs/intl'
import type { Dictionary, Language } from './types'
import type { TranslationKey } from './types'
import { flattenObject } from './utils'

const cache = createIntlCache()

export type Replacements = Record<string, any>
export type Locale = Record<TranslationKey, string>
const intlMessages = {} as Record<Language, IntlShape<TranslationKey>>

export const getDictionary = (languageCode: Language) => {
	const locale = require(`./locales/${languageCode}`)

	if (!locale) {
		throw new Error(`No locale for ${languageCode}`)
	}

	return locale.translations as Dictionary
}

export const getLocale = (languageCode: Language) => {
	return flattenObject(getDictionary(languageCode)) as Locale
}

export const createIntlShape = (languageCode: Language, messages: Locale) => {
	return createIntl<TranslationKey>(
		{
			locale: languageCode,
			messages,
		},
		cache,
	)
}

const initLanguage = (languageCode: Language) => {
	const flat = getLocale(languageCode)

	intlMessages[languageCode] = createIntl<TranslationKey>(
		{
			locale: languageCode,
			messages: flat,
		},
		cache,
	)
}

// Not in use currently, but we'll keep it here for when backend code needs translations
export const getTranslation = (
	key: TranslationKey,
	values: Replacements = {},
	languageCode: Language = 'nb',
) => {
	if (!intlMessages[languageCode]) {
		initLanguage(languageCode)
	}

	try {
		return intlMessages[languageCode].formatMessage({ id: key }, values)
	} catch (error) {
		logger.error(`Missing translation for ${languageCode}.${key}`)
		return `Missing translation for ${languageCode}.${key}`
	}
}
